import React, { Component } from 'react';

import { grey } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';

import { WalletColumnConstants } from '../../../config/constants';

import WalletCard from './WalletCard';
import VirtualTransaction from './VirtualTransaction';

const styles = (theme) => ({
  walletColumn: {
    width: `${WalletColumnConstants.transactionColumnWidth}px`,
    display: 'inline-block',
    marginRight: `${WalletColumnConstants.transactionColumnMargin}px`,
    verticalAlign: 'top',
    position: 'relative',
  },
  transaction: {
    position: 'absolute',
    left: 0,
    right: 0,
    height: `${WalletColumnConstants.transactionRowHeight}px`,
  },
  lifeline: {
    position: 'absolute',
    left: `${WalletColumnConstants.transactionColumnWidth / 2 - 4}px`,
    right: `${WalletColumnConstants.transactionColumnWidth / 2 - 4}px`,
    top: 0,
    bottom: 0,
    background: grey[400],
    zIndex: -1,
  },
});

class WalletColumn extends Component {
  render() {
    const { classes, wallet } = this.props;

    const rows = new Array(this.props.numberOfRows);
    const virtualTransactions = wallet.virtualTransactions;
    for (
      let row = 0, virtualTransactionIndex = 0;
      row < this.props.numberOfRows;
      ++row
    ) {
      rows[row] = {
        key: this.props.wallet.walletId + '_' + row,
      };
      const virtualTransaction = virtualTransactions[virtualTransactionIndex];
      if (virtualTransaction && virtualTransaction.displayRow === row) {
        rows[row].virtualTransaction = virtualTransaction;
        virtualTransactionIndex++;
      }
    }

    return (
      <div className={classes.walletColumn}>
        <WalletCard wallet={wallet} />
        {rows.map((row, index) => (
          <div
            key={row.key}
            className={classes.transaction}
            style={{
              top: `${
                WalletColumnConstants.walletCardHeight +
                index * WalletColumnConstants.transactionRowHeight
              }px`,
            }}
          >
            <div className={classes.lifeline}></div>
            {!!row.virtualTransaction && (
              <VirtualTransaction
                virtualTransaction={row.virtualTransaction}
                displayColumn={wallet.displayColumn}
              />
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default withStyles(styles)(WalletColumn);
